export default __webpack_public_path__ + "static/shooting-medl-79bc7bdcce13b4041250b9df7168afb5.jpg";